module.exports = __webpack_public_path__ + "img/language.b82c6bae.svg";